enum FieldInputSize {
  lg = 'lg',
}

export { FieldInputSize };
